// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"468a7ce0","247":"f66797ba","422":"f70ac624","627":"227915a4","867":"7502becd","923":"93072ebe","938":"2c85aa72"}[chunkId] + ".chunk.js";
};